import { render, staticRenderFns } from "./ServiceTipologyDD.vue?vue&type=template&id=51d7212a&"
import script from "./ServiceTipologyDD.vue?vue&type=script&lang=js&"
export * from "./ServiceTipologyDD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports